import React, { memo } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";

import { PopoverText } from '../../common/parts/PopoverText';

import { userState } from '../../../store/userState';
import { loadingState } from '../../../store/loadingState';
import { isSurveyState } from '../../../store/isSurveyState';
import { confirmState } from '../../../store/confirmState';
import { orderState } from '../../../store/orderState';
import { optionState } from '../../../store/optionState';
import { courceClinicState } from '../../../store/courceClinicState';
import { selectedCourceClinicState } from '../../../store/selectedCourceClinicState';
import { selectedCourceVenueState } from '../../../store/selectedCourceVenueState';
import { courceItemState } from '../../../store/courceItemState';
import { courceVenueState } from '../../../store/courceVenueState';

export const CourceRadio = memo((props) => {
  const { item } = props;
  const isConfirm = useRecoilValue(confirmState);
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [optionData, setOptionData] = useRecoilState(optionState);
  const [courceClinicData, setCourceClinicData] = useRecoilState(courceClinicState);
  const [selectedCourceClinic, setSelectedCourceClinic] = useRecoilState(selectedCourceClinicState);
  const [selectedCourceVenue, setSelectedCourceVenue] = useRecoilState(selectedCourceVenueState);
  const [courceItemData, setCourceItemData] = useRecoilState(courceItemState);
  const [courceVenueData, setCourceVenueData] = useRecoilState(courceVenueState);
  const userData = useRecoilValue(userState);
  const [loading, setLoading] = useRecoilState(loadingState);
  const [isSurvayData, setIsSurvayData] = useRecoilState(isSurveyState);
  const initialSelectedCourceVenue = {
    id: '',
    clinic_id: null,
    name: null,
    prefecture_code: null,
    address: null,
  }
  const initialSelectedCourceClinic = {
    id: '',
    clinic_id: null,
    name: null,
    prefecture_code: null,
    address: null,
    tel: null,
  }

  // 検査オプション未選択状態に設定(選択後にも対応する為)
  const resetSelectOptionsCheckbox = () => {
    const selectOptionsCheckbox = document.getElementsByName("selectOptions");
    selectOptionsCheckbox.forEach(e => {
      e.checked = false
    });
  }

  // Seiken(CourceItem)[120..149]の枠を取得
  const getCourceItem = async (data) => {
    setLoading(true);
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/cource_items`, data)
                .then(resp => {
                  console.log("get CourceItems success");
                  console.log(resp.data);
                  setCourceItemData(resp.data.cource_items);
                })
                .catch(e => {
                  console.log("CourceItems error");
                  console.log(e.response);
                })
                .finally(()=> {
                  setLoading(false);
                });
    return res;
  }

  // Seiken(CourceOption)[120..149]の枠を取得
  const getOptions = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/cource_options`, data)
                .then(resp => {
                  console.log("get options success");
                  console.log(resp.data);
                  setOptionData(resp.data.options);
                })
                .catch(e => {
                  console.log("options error");
                  console.log(e.response);
                });
    return res;
  }

  const onClickCource = (item) => {
    setSelectedCourceClinic(initialSelectedCourceClinic);
    setSelectedCourceVenue(initialSelectedCourceVenue);
    setCourceClinicData(null);
    setCourceItemData(null)
    setCourceVenueData(null)
    resetSelectOptionsCheckbox();
    setOptionData(null);
    setIsSurvayData(false);
    setOrderData({
      ...orderData,
      cource_id: item.id,
      cource_code: item.code,
      requestcource: item.name,
      requestcource_clinic_id: '',
      requestpref_code: '',
      requestclinic_id: null,
      requestclinic: null,
      options: [],
      requestdt1: null,
      requestdt1_ampm: '0',
      requestdt2: null,
      requestdt2_ampm: '0',
      requestdt3: null,
      requestdt3_ampm: '0',
      requestnote: '',
      examdt: null,
      examdtime: '',
      item_id: null,
    });

    if (120 <= parseInt(item.code, 10) && parseInt(item.code, 10) < 149) {
      // Seiken(CourceItem)[120..149]
      var data = { params: { 
        cource_id: item.id,
        user_id: userData.user_id,
      }};
      getCourceItem(data);
      getOptions(data);
    }
  }

  return (
    <>
      <div className="list-group-item">
        <input className="form-check-input me-1" type="radio" name="selectCourse" id={`cource${item.id}`} onClick={() => onClickCource(item)} disabled={isConfirm} defaultChecked={item.id == orderData.cource_id} />
        <label className="form-check-label" htmlFor={`cource${item.id}`}>
          {item.name}
        </label>
        <PopoverText textTitle={item.name} textBody={item.description} />
      </div>
    </>
  );
});